import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const NewsletterPage = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Subscribed Successfully!",
      description: "You'll receive our weekly newsletter with balanced news coverage."
    });
    setEmail('');
    setName('');
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <Mail size={48} className="mx-auto mb-4 text-gray-600" />
        <h1 className="text-4xl font-serif font-bold mb-4">
          Subscribe to Our Newsletter
        </h1>
        <p className="text-gray-600 text-lg">
          Get balanced news coverage and counter-perspectives delivered to your inbox every week
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Weekly Newsletter</CardTitle>
          <CardDescription>
            Stay informed with the other side of the story
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="name">Name</Label>
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
              />
            </div>

            <div>
              <Label htmlFor="email">Email Address *</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                required
              />
            </div>

            <Button type="submit" className="w-full" size="lg">
              Subscribe Now
            </Button>
          </form>

          <div className="mt-8 space-y-4 text-sm text-gray-600">
            <h3 className="font-bold text-gray-900">What you'll receive:</h3>
            <ul className="space-y-2">
              <li>• Weekly digest of counter-stories and balanced perspectives</li>
              <li>• Breaking news when major one-sided stories are published</li>
              <li>• Community updates and opportunities to share your story</li>
              <li>• No spam, unsubscribe anytime</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewsletterPage;